<template>
	<div class="friend-request-item">
		<div class="friend-avatar">
			<head-image :size="40" :id="friend.id" :name="friendDisplayName" :url="friend.headImage"></head-image>
		</div>
		<div class="request-info">
			<div class="name-text" :title="friendDisplayName">{{ friendDisplayName }}</div>
			<div class="info-text" :title="requestDescription">{{ requestDescription }}</div>
		</div>
		<div class="btn-group">
			<el-button v-if="!isSender" plain size="mini" :disabled="submitting" @click="onReject">拒绝</el-button>
			<el-button v-if="!isSender" type="primary" size="mini" :loading="submittingAction === 'approve'" :disabled="submitting" @click="onApprove">同意</el-button>
			<el-button v-if="isSender" plain size="mini" :loading="submittingAction === 'recall'" :disabled="submitting" @click="onRecall">撤回</el-button>
		</div>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';

export default {
	name: "frinedRequestItem",
	components: {
		HeadImage
	},
	data() {
		return {
			submittingAction: ""
		}
	},
	methods: {
		startAction(action) {
			if (this.submittingAction) {
				return false;
			}
			this.submittingAction = action;
			return true;
		},
		finishAction() {
			this.submittingAction = "";
		},
		onApprove() {
			if (!this.startAction('approve')) {
				return;
			}
			this.friendStore.approveFriendRequest(this.request.id).then(() => {
				this.friendStore.removeRequest(this.request.id);
				this.$message.success(`${this.request.sendNickName} 已成为您的好友`);
			}).finally(() => {
				this.finishAction();
			})
		},
		onReject() {
			if (!this.startAction('reject')) {
				return;
			}
			this.friendStore.rejectFriendRequest(this.request.id).then(() => {
				this.friendStore.removeRequest(this.request.id);
				this.$message.success(`您拒绝了 ${this.request.sendNickName} 的好友请求`);
			}).finally(() => {
				this.finishAction();
			})
		},
		onRecall() {
			if (!this.startAction('recall')) {
				return;
			}
			this.friendStore.recallFriendRequest(this.request.id).then(() => {
				this.friendStore.removeRequest(this.request.id);
				this.$message.success(`您撤回了 ${this.request.recvNickName} 的好友请求`);
			}).finally(() => {
				this.finishAction();
			})
		}
	},
	props: {
		request: {
			type: Object
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		isSender() {
			// 我是否发起方
			return this.request.sendId == this.mine.id;
		},
		friend() {
			if (this.isSender) {
				return {
					id: this.request.recvId,
					nickName: this.request.recvNickName,
					headImage: this.request.recvHeadImage,
				}
			} else {
				return {
					id: this.request.sendId,
					nickName: this.request.sendNickName,
					headImage: this.request.sendHeadImage,
				}
			}
		},
		friendDisplayName() {
			return this.friend.nickName || this.request.recvNickName || this.request.sendNickName || '';
		},
		submitting() {
			return Boolean(this.submittingAction);
		},
		requestDescription() {
			if (this.request.remark) {
				return this.request.remark;
			}
			return this.isSender ? '请求添加对方为好友' : '请求添加您为好友';
		}
	}

}
</script>

<style scoped lang="scss">
.friend-request-item {
	display: grid;
	grid-template-columns: auto minmax(0, 1fr) auto;
	position: relative;
	align-items: center;
	justify-items: stretch;
	cursor: default;
	margin: 0;
	width: 100%;
	min-height: 72px;
	padding: 12px 0;
	border-bottom: 1px solid rgba(var(--im-black-rgb), 0.06);
	gap: 14px;

	.friend-avatar {
		flex-shrink: 0;

		:deep(.head-image) {
			border: 1px solid rgba(var(--im-black-rgb), 0.08);
		}
	}

	.request-info {
		margin: 0;
		width: 100%;
		min-width: 0;
		display: flex;
		flex-direction: column;
		align-items: stretch;
		justify-content: center;
		overflow: hidden;
		gap: 6px;
		text-align: left;

		.name-text {
			display: block;
			width: 100%;
			margin: 0;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			font-weight: 600;
			font-size: 14px;
			line-height: 20px;
			color: var(--im-text-color);
			text-align: left !important;
		}

		.info-text {
			display: block;
			width: 100%;
			margin: 0;
			display: block;
			word-break: break-all;
			font-size: 13px;
			line-height: 1.5;
			text-align: left !important;
			color: var(--im-text-color-light);
		}

	}

	.btn-group {
		display: inline-flex;
		align-items: center;
		flex-wrap: wrap;
		justify-content: flex-end;
		gap: 8px;
		flex-shrink: 0;

		:deep(.el-button) {
			min-width: 68px;
			height: 30px;
			padding: 0 12px;
			border-radius: 7px;
			box-shadow: none;
		}
	}

	@media (max-width: 640px) {
		align-items: flex-start;

		.btn-group {
			flex-direction: column;
			align-items: stretch;
			width: 72px;
		}
	}
}
</style>
